import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind utilities win over earlier ones.
 *
 * `clsx` alone would keep both `p-2` and `p-4`, and which one applies would
 * then depend on their order in the generated stylesheet rather than on the
 * order they were passed. `twMerge` resolves that by dropping the loser.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
